export type ActionItemProps = {
  title: string;
  subtitle?: string;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  onClick?: () => void;
  type?: ActionItemType;
};

export enum ActionItemType {
  Regular = "regular",
  Modal = "modal",
}
